import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { fontWeight, TypographyStyledGlobal, colors, fontSize } from '../../../theme';
import { HeaderHotAlertTitleStyled } from '../styled';
import { ReactComponent as EmojiAngry } from '../../../assets/hotAlert/angry.svg';
import { ReactComponent as EmojiHappy } from '../../../assets/hotAlert/happy.svg';
import { ReactComponent as EmojiNeutral } from '../../../assets/hotAlert/neutral.svg';

interface HotAlertDetailsHeaderProps {
    name: string;
    satisfaction: {
        isSatisfy: boolean
        isUnsatisfy: boolean
        satisfactionLabel: string
    }
}

const HotAlertDetailsHeader: FC<HotAlertDetailsHeaderProps> = ({ name, satisfaction }) => {
    const { t } = useTranslation('hotAlerts');
    const nameToDisplay = name === ' ' ? 'Le répondant' : name;

    return (
        <HeaderHotAlertTitleStyled>
            <div>
                <TypographyStyledGlobal
                    color={colors.grey100}
                    margin='15px 0 0 0'
                    size={fontSize.l}
                    sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                    weight={fontWeight.bold}
                >
                    {satisfaction !== null && t('details.title', { name: nameToDisplay, satisfaction: satisfaction.satisfactionLabel })}
                    {satisfaction !== null && satisfaction.isSatisfy && <EmojiHappy />}
                    {satisfaction !== null && !satisfaction.isSatisfy && satisfaction.isUnsatisfy && <EmojiAngry />}
                    {satisfaction !== null && !satisfaction.isSatisfy && !satisfaction.isUnsatisfy && <EmojiNeutral />}
                </TypographyStyledGlobal>
                <TypographyStyledGlobal
                    color={colors.grey200}
                    margin='12px 0 48px 0'
                    size={fontSize.m}
                    sx={{ lineHeight: '24px' }}
                    weight={fontWeight.semiRegular}
                />
            </div>
            {/* <Link  to='/settings#hot-alerts'>
                <SettingsOutlinedIconStyled />
            </Link> */}
        </HeaderHotAlertTitleStyled>
    );
};

export default HotAlertDetailsHeader;
